import { InjectionToken } from '@angular/core';
import { Environment } from '@models';

export const ENV = new InjectionToken<Environment>('ENV');
export const SHOP_NAME = new InjectionToken<string>('SHOP_NAME');
export const DEFAULT_LOCALE = new InjectionToken<string>('DEFAULT_LOCALE');
